import { call, put, takeLatest, select } from 'redux-saga/effects';
import { callWithAuth } from '../sagaApiHelper';
import { sendEmailApi } from '../../api/apiLists/sendEmailApi';
import { showAlert } from '../alertSlice';
import { setLoading, setSuccess, setError, resetEmailState } from '../emailSlice';

function* handleSendEmail(action) {
  try {
    yield put(setLoading(true));
    const payload = action.payload || {};

    // Get company info from Redux state
    const companyInfo = yield select(state => state.companyInfo?.info || {});
    
    // Extract only required company info fields
    const companyData = {
      companyName: companyInfo.name || '',
      companyEmail: companyInfo.supportEmail || '',
      companyCallNumber: companyInfo.supportPhone || '',
      companyWhatsappNumber: companyInfo.supportWhatsApp || ''
    };

    // Combine payload with company info
    const finalPayload = {
      ...payload,
      ...companyData
    };

    const res = yield call(callWithAuth, sendEmailApi, finalPayload);

    if (res?.status === true) {
      yield put(setSuccess(true));
      yield put(showAlert({ message: 'Email sent successfully', type: 'success' }));
      yield put(resetEmailState());
    } else {
      yield put(setError(res?.errMsg || 'Failed to send email'));
      yield put(showAlert({ message: res?.errMsg || 'Failed to send email', type: 'error' }));
    }
  } catch (error) {
    console.error('Error sending email:', error);
    yield put(setError('Error occurred while sending email'));
    yield put(showAlert({ message: 'Error occurred while sending email', type: 'error' }));
  } finally {
    yield put(setLoading(false));
  }
}

export default function* emailSaga() {
  yield takeLatest('SEND_EMAIL', handleSendEmail);
}
